<template>
  <v-select
    :items="invoiceFrequenciesList"
    item-value="id"
    item-text="name"
    v-model="idValue"
    label="Invoice Frequency"
    :rules="[requiredCheck()]"
    :disabled="disabled"
    :clearable="clearable ? clearable : false"
    :readonly="readOnly ? readOnly : false"
    outlined
  ></v-select>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'id',
    'isRequired',
    'disabled',
    'clearable',
    'readOnly'
  ],
  computed: {
    ...mapFields('invoiceFrequencies', [
      'invoiceFrequenciesList'
    ]),
    idValue: {
      get () {
        return this.id
      },
      set (newValue) {
        this.$emit('change', newValue)
      }
    }
  },
  methods: {
    ...mapActions('invoiceFrequencies', [
      'getInvoiceFrequencies'
    ]),
    requiredCheck () {
      return !this.isRequired || required('Invoice Frequency')
    }
  },
  created () {
    this.getInvoiceFrequencies()
  }
}
</script>
